import { Fragment } from "react";
import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";

import {
  TRAINING_DAYS,
  //WorkingSets,
} from "@/app/training/training";
import { dayNames } from "@/app/training/training-day";

// Mapeo de abreviaturas a nombres completos (solo para visualización)


type MusclesProps = {
  id: string | number;
  monday?: string[];
  tuesday?: string[];
  wednesday?: string[];
  thursday?: string[];
  friday?: string[];
  saturday?: string[];
  sunday?: string[];
};

type SeriesProps = {
  id: string | number;
  monday?: string | number;
  tuesday?: string | number;
  wednesday?: string | number;
  thursday?: string | number;
  friday?: string | number;
  saturday?: string | number;
  sunday?: string | number;
};

export type TableListSeriesMusclesProps = {
  isLoading: boolean;
  //workingSets: WorkingSets;
  workingSets: {
    value: {
      series: string;
      muscles: [];
    };
  };
  title: string;
};

const TableListSeriesMuscles: React.FC<TableListSeriesMusclesProps> = ({
  workingSets,
  isLoading,
  title,
}) => {

  if (!workingSets) {
    return null;
  }

  return (
    <div className="px-1">
      <div className="sm:flex items-center">
        <div className="flex-grow">
          <h1 className="text-base font-semibold leading-6 text-gray-900 mt-5">
            {title}
          </h1>
        </div>
      </div>
      <div className="flow-root">
        {!isLoading === false ? (
          <>
            <div className="flex justify-center items-center m-10">
              <FontAwesomeIcon icon={faLoader} spin className="text-6xl" />
            </div>
          </>
        ) : (
          <>
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8">
                <div className="border-b border-l border-r border-gray-300 mt-2"></div>
                <Fragment>
                  <table className="min-w-full divide-y divide-gray-300 border-l border-r border-b border-gray-300 ">
                    <thead>
                      <tr>
                        {TRAINING_DAYS?.map((day) => (
                          <th
                            key={day} // Añadí una key para evitar advertencias de React
                            scope="col"
                            className="text-center py-3.5 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:pl-3"
                          >
                            {dayNames[day]}{" "}
                            {/* Reemplazo visual a nombre completo */}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      <tr>
                        {workingSets && Object?.entries(workingSets).map(([, value]) => (
                          <td className="text-center text-sm text-gray-500 px-3 py-2">
                            <span>
                              {value?.series === 0 ? "" : value?.series}
                            </span>
                          </td>
                        ))}
                      </tr>
                      <tr>
                        {Object.entries(workingSets).map(([, value]) => (
                          <td className="text-center text-sm text-gray-500 px-3 py-2">
                            {value?.muscles?.map((muscle, index) => (
                              <>
                                <span key={index}>{muscle}</span>
                                <br />
                              </>
                            ))}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </Fragment>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TableListSeriesMuscles;
